export enum BrandSubscriptionNotification {
  orderConfirmation = 'order-confirmation',
  subscriptionCancelled = 'subscription-cancelled',
}
